import qs from 'qs';

export const isSlugReferer = (value?: string | null): value is string =>
  !!value && !/^https?:\/\//i.test(value);

export const getSlugRefererFromSearch = (search: string): string | undefined => {
  const { referer } = qs.parse(search, { ignoreQueryPrefix: true });

  return isSlugReferer(referer as string | undefined) ? (referer as string) : undefined;
};

export const getPrequalOriginFromSearch = (search: string): string | undefined => {
  const { origin } = qs.parse(search, { ignoreQueryPrefix: true });

  return (origin as string) || undefined;
};

export const hrefForReferer = (referer: string, origin?: string): string => {
  if (!isSlugReferer(referer)) {
    return referer;
  }

  const url = new URL('/', window.location.origin);
  url.searchParams.set('referer', referer);

  if (origin) {
    url.searchParams.set('origin', origin);
  }

  return url.toString();
};

export const hrefForApplicationLink = (link: string, referer: string): string => {
  try {
    const url = new URL(link, window.location.origin);
    url.searchParams.set('referer', referer);

    return `${window.location.origin}${url.pathname}${url.search}${url.hash}`;
  } catch {
    return `${link}&referer=${encodeURIComponent(referer)}`;
  }
};
